import { render } from "./pricing-modal.vue?vue&type=template&id=452c8600"
import script from "./pricing-modal.vue?vue&type=script&lang=js"
export * from "./pricing-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__